import fetchWithLogjam from './fetch-with-logjam';
import addCsrfHeader from './csrfHeader';

export default (url, options) => fetchWithLogjam(url, addCsrfHeader(options));
